angular.module('app.scouting').component('scoutingReportRatingLegend', {
  templateUrl: 'scouting/components/field/partials/rating-legend.html',
  bindings: {
    scales: '<',
    mode: '@',
  },
});
